import React from "react";
import { CheckCircle } from "lucide-react";
import Eventcycle from "./Eventcycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
const travelLeadData = {
  heading: "Skyrocket Your Events with WhatsApp | ChatMitra",
  points: [
    "Fill seats fast with instant WhatsApp invites.",
    "Keep attendees in the loop with smart reminders.",
    "Make every event a hit with real-time updates.",
  ],
  buttons: [
    { text: "Get Start ", className: "bg-[#075E54] text-white hover:bg-[#076M54]" ,buttonLink:"https://app.chatmitra.com/signin"},
    { text: "Book a Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/event_and_webinar/event_and_webinar_1.png",
};

const eventServices = [
  {
    id: 1,
    icon: <span className="text-2xl">🎉</span>, // Party icon
    title: "Boost Ticket Sales with WhatsApp Campaigns",
    description: "Promote your events and sell tickets directly through WhatsApp. It’s like having a personal concierge for every attendee—fast, easy, and effective!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">📅</span>, // Calendar icon
    title: "Simplify Event Scheduling on WhatsApp",
    description: "Let attendees book seats, workshops, or VIP passes via WhatsApp. It’s a breeze to manage dates, times, and confirmations all in one chat."
  },
  {
    id: 3,
    icon: <span className="text-2xl">📢</span>, // Megaphone icon
    title: "Spread the Word with WhatsApp Alerts",
    description: "Send last-minute updates, reminders, and promotions via WhatsApp to keep your audience excited and engaged. It’s the ultimate buzz builder!"
  },
  {
    id: 4,
    icon: <span className="text-2xl">📍</span>, // Location pin icon
    title: "Share Venue Details via WhatsApp",
    description: "Guide attendees with maps, parking info, and directions right in WhatsApp. They’ll arrive stress-free and ready to enjoy your event."
  },
  {
    id: 5,
    icon: <span className="text-2xl">💬</span>, // Chat bubble icon
    title: "Offer Real-Time Support on WhatsApp",
    description: "Answer questions, handle complaints, and provide live updates during events through WhatsApp. Your attendees will feel cared for every step of the way."
  },
  {
    id: 6,
    icon: <span className="text-2xl">⭐</span>, // Star icon
    title: "Gather Feedback with WhatsApp Surveys",
    description: "Post-event, use WhatsApp to collect reviews, ratings, and suggestions. It’s a simple way to improve future events and build loyalty."
  }
];

const eventFAQs = [
  {
    question: "How can WhatsApp help promote my events?",
    answer: "WhatsApp can skyrocket your event visibility by sending targeted ads, reminders, and exclusive offers. It’s like having a megaphone that reaches your audience directly, driving more ticket sales!"
  },
  {
    question: "Can attendees book tickets on WhatsApp?",
    answer: "Yes! Customers can purchase tickets, reserve seats, or sign up for workshops via WhatsApp. It’s like having a ticket booth that’s open 24/7, making bookings a breeze."
  },
  {
    question: "Is WhatsApp secure for event planning?",
    answer: "Absolutely! WhatsApp’s encryption keeps attendee data and payment details safe. It’s like locking your event plans in a vault, so you and your clients can focus on the fun."
  },
  {
    question: "How does WhatsApp handle live event updates?",
    answer: "Send real-time updates like schedule changes, speaker announcements, or weather alerts via WhatsApp. It’s like having a live announcer in everyone’s pocket, keeping your audience informed and engaged."
  },
  {
    question: "Can WhatsApp manage event logistics?",
    answer: "Yes! Coordinate vendors, share venue maps, and track RSVPs through WhatsApp. It’s like having a central hub that keeps everything—and everyone—on track."
  },
  {
    question: "How do I engage attendees before and after events?",
    answer: "Use WhatsApp to send pre-event hype, post-event thank-yous, and feedback requests. It’s like building a community around your events, turning one-time attendees into regulars."
  },
  {
    question: "Can WhatsApp reduce event planning stress?",
    answer: "Definitely! Automate ticket confirmations, reminders, and queries via WhatsApp, freeing you up to focus on the big picture. It’s like having an assistant who handles the details."
  },
  {
    question: "What kind of content can I share on WhatsApp for events?",
    answer: "Share event agendas, speaker bios, and exclusive sneak peeks via WhatsApp. It’s a direct line to build excitement and keep your audience hooked."
  },
  {
    question: "How do attendees feel about using WhatsApp for events?",
    answer: "They love it! Attendees appreciate the convenience, speed, and personal touch of WhatsApp. It’s less formal than emails and more immediate, making event planning feel effortless."
  },
  {
    question: "How do I set up WhatsApp for my event business?",
    answer: "Start by integrating WhatsApp Business, creating chat templates for tickets and updates, and training your team. Tools like ChatMitra can guide you through a quick, effective setup!"
  },
];

const Event = () => {
  return (
    <>
      <section className="flex flex-col md:flex-col lg:flex-row gap-8 md:gap-12 bg-white max-w-6xl mx-auto mt-32 mb-10 px-6 sm:px-0 ">
        <div className="w-full md:w-full lg:w-1/2 text-left md:pl-8 mb-8 md:mb-0">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-tight">
            {travelLeadData.heading}
          </h1>
          <p className="text-lg text-gray-700 mb-6">
            Learn how WhatsApp for events boosts sign-ups and keeps attendees engaged with ChatMitra’s simple tools.
          </p>
          <ul className="mt-6 sm:mt-8 space-y-4 sm:space-y-6 text-lg">
            {travelLeadData.points.map((point, index) => (
              <li key={index} className="flex items-start">
                <CheckCircle className="text-[#075E54] w-4 h-4 mr-2 self-center flex-shrink-0" strokeWidth={3} />
                {point}
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap gap-4 justify-left md:justify-start">
            {travelLeadData.buttons.map((button, index) => (
              <a
              key={index}
              href={button.buttonLink}
              className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
            >
              {button.text}
            </a>
            ))}
          </div>
        </div>
        <div className="w-full md:w-full lg:w-1/2 flex justify-center">
          <img
            src={travelLeadData.image}
            alt="WhatsApp for Events Invite Flow"
            className="max-w-full h-auto rounded-lg border-transparent transition-all duration-500"
          />
        </div>
      </section>
      <Eventcycle />


      <WhatsAppServices servicesData={eventServices} isVisible={true}/>

      <Faqs faqs={eventFAQs} />
      <title>Skyrocket Your Events with WhatsApp | ChatMitra</title>
      <meta name="description" content="Boost event attendance with WhatsApp for events. ChatMitra automates invites, reminders, payments, and feedback for seamless webinars and gatherings." />
      <meta name="keywords" content="WhatsApp for events, event automation, webinar engagement, event sign-ups, WhatsApp chatbot, ChatMitra" />
      <link rel="canonical" href="https://blog.chatmitra.com/whatsapp-for-events" />
      <meta property="og:title" content="Skyrocket Your Events with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Maximize event success with WhatsApp for events. Automate registrations, send reminders, and collect feedback easily with ChatMitra." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-for-events" />
      <meta property="og:type" content="website" />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "WhatsApp for Events",
            "provider": {
              "@type": "Organization",
              "name": "ChatMitra"
            },
            "description": "Increase event and webinar attendance with WhatsApp automation for invites, reminders, payments, and feedback collection."
          }
        `}
      </script>
      <Footer />
    </>
  );
};

export default Event;